import { get as _get } from "lodash-es";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { fetchUpdates } from "../actions/sync";
import { getLastSynced } from "../selectors/sync";

// TODO: could be merged with SyncPushService, so
// there's no race condition on pull and push

const mapStateToProps = (state) => ({
  // TODO: should rather save nextLastUpdate from response,
  // to avoid repeatedly getting recently deleted objects
  getLastSynced: () => getLastSynced(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchUpdates: (lastSynced) => dispatch(fetchUpdates(lastSynced)),
});

class SyncPullService extends React.Component {
  intervalId = null;
  lastSynced = null;
  componentDidMount() {
    this.intervalId = setInterval(this.runSync, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  runSync = () => {
    const lastSynced = this.lastSynced || this.props.getLastSynced();
    if (lastSynced) {
      this.props.fetchUpdates(lastSynced).then((action) => {
        const nextLastUpdate = _get(action, "payload.data.nextLastUpdate");
        if (nextLastUpdate) {
          this.lastSynced = nextLastUpdate;
        }
      });
    }
  };

  render() {
    return null;
  }
}

SyncPullService.propTypes = {
  getLastSynced: PropTypes.func.isRequired,
  fetchUpdates: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SyncPullService);
